import { Pipe, PipeTransform }    from "@angular/core";
import { FormuleEnum }            from "@shared/enums/formule.enum";
import { PriceFormuleParameters } from "../../components/main/oav-phase-b/preconisation/priceFormuleParameters";
import { ErrorOnFormgroup } from "../errors/errorOnFormgroup";
import { isNotNull } from "@shared/helper/LDHelper";


@Pipe({ standalone: true, name: "CheckShowMontantTarificationPhaseBPipe" })
export class CheckShowMontantTarificationPhaseBPipe implements PipeTransform {
  transform(prices: PriceFormuleParameters[], formule: FormuleEnum, key: string, errorOnFormgroup: ErrorOnFormgroup): boolean {
    let next = false;
    const elementPrice = prices.find(c => c.formuleEnum === formule);
    if (!elementPrice) {
      console.error(`no element price found for formule [${formule}]`);
    }
    const hasError = errorOnFormgroup && errorOnFormgroup.hasError;
    if (!!elementPrice && !hasError) {
      const mnt = elementPrice.price[key];
      next = isNotNull(mnt) && mnt !== 0;
    }
    return next;
  }
}
